// utils/showErrorSwal.ts
import Swal from 'sweetalert2';

export const showDetailedErrorSwal = (response: {
    message: string;
    errorDetails: Record<string, any>;
}) => {
    const { message, errorDetails } = response;

    const formattedDetails = JSON.stringify(errorDetails, null, 2); // Pretty JSON

    Swal.fire({
        icon: 'error',
        title: message || 'An error occurred',
        html: `
      <button id="toggleDetails" style="
        margin-top: 10px;
        background-color: #eee;
        border: 1px solid #ccc;
        padding: 5px 10px;
        cursor: pointer;
        border-radius: 5px;
      ">View Details</button>
      <div id="errorDetails" style="display:none; margin-top: 10px; text-align: left; max-height: 300px; overflow: auto;">
        <pre style="white-space: pre-wrap; font-size: 12px; background: #f9f9f9; padding: 10px; border: 1px solid #ddd;">
${formattedDetails}
        </pre>
      </div>
    `,
        confirmButtonText: 'Close',
        didOpen: () => {
            const toggleBtn = document.getElementById('toggleDetails');
            const detailBox = document.getElementById('errorDetails');
            let isVisible = false;

            toggleBtn?.addEventListener('click', () => {
                isVisible = !isVisible;
                if (detailBox) {
                    detailBox.style.display = isVisible ? 'block' : 'none';
                }
                toggleBtn.innerText = isVisible ? 'Hide Details' : 'View Details';
            });
        }
    });
};
